export default [
  {
    path: '/roles',
    name: 'roles',
    component: () => import('./views/RolesList'),
    meta: {
      auth: true
    }
  },
  {
    path: '/roles/new',
    name: 'roles.new',
    component: () => import('./views/RolesCreate'),
    meta: {
      auth: true
    }
  },
  {
    path: '/roles/:name',
    name: 'roles.edit',
    component: () => import('./views/RolesCreate'),
    meta: {
      auth: true
    }
  }
]
